import { pushTrackingData } from '../../lib/dataLayer';
import WidgetBase from '../widget.base';

export default class MoviesComponent extends WidgetBase {
    static selector = '[data-js-movies]';

    constructor(el) {
        super(el);
        const moviePosterLinkSelector = 'a:has(.widgetWL-imageFilm)';
        const moviePosterLinkContentSelector = `${moviePosterLinkSelector} > .widgetWL-imageFilm`;

        const movieTitleLinkSelector = 'a:has(.widgetWL-titleFilm)';
        const movieTitleLinkContentSelector = `${movieTitleLinkSelector} > .widgetWL-titleFilm`;

        const movieDetailsSelectors = `${moviePosterLinkSelector}, ${moviePosterLinkContentSelector}, ${movieTitleLinkSelector}, ${movieTitleLinkContentSelector}`;

        const movieShowTimeButtonSelector = '.widgetWL-timesList button, .widgetWL-timesList input[type="button"]';

        el.addEventListener('click', (e) => {
            const { target } = e;

            if (target.matches(movieDetailsSelectors)) {
                const data = getMovieDetailsData(target);

                pushTrackingData(data);
            }
            else if (target.matches(movieShowTimeButtonSelector)) {
                const data = getMovieShowTimeData(target);

                pushTrackingData(data);
            }
        });


        setTimeout(() => {
            this.loaded();
        });
    }
}

function getMovieDetailsData(element) {
    const movieName = getMovieName(element);

    return {
        'name': 'movie_details',
        'movie_name': movieName
    };
}

function getMovieShowTimeData(element) {
    const movieName = getMovieName(element);
    const showTime = getMovieShowDateTime(element);

    return {
        'name': 'movie_showtime',
        'movie_name': movieName,
        'showtime': showTime
    };
}

function getMovieShowDateTime(element) {
    const dateDisplay = getMovieShowDate(element);
    const timeDisplay = getMovieShowTime(element);

    return `${dateDisplay} at ${timeDisplay}`;
}

function getMovieShowDate(element) {
    const container = element.closest('.widgetWL-contentCinema');
    if (typeof(container) === 'undefined' || container === null) {
        return '';
    }

    const selectedDate = container.querySelector('.linkItemDatesFilm.active');
    if (typeof(selectedDate) === 'undefined' || selectedDate === null) {
        return '';
    }

    const day = selectedDate.querySelector('span:first-child');
    if (typeof(day) === 'undefined' || day === null) {
        return '';
    }

    const date = selectedDate.querySelector('span:last-child');
    if (typeof(date) === 'undefined' || date === null) {
        return '';
    }

    return `${day.innerText.trim()}, ${date.innerText.trim()}`;
}

function getMovieShowTime(element) {
    const { value } = element;

    return value
    .replace(' PM', 'PM')
    .replace(' AM', 'AM');
}


function getMovieName(element) {
    const item = getMovieItem(element);
    if (typeof (item) === 'undefined') {
        return '';
    }

    const title = item.querySelector('.widgetWL-titleFilm');
    if (typeof (item) === 'undefined') {
        return '';
    }

    return title.innerText;
}

function getMovieItem(element) {
    const item = element.closest('.widgetWL-itemFilm');
    if (typeof (item) === 'undefined' || item === null) {
        return undefined;
    }

    return item;
}